import { render, staticRenderFns } from "./testTask.vue?vue&type=template&id=6a5fc5a2&"
import script from "./testTask.vue?vue&type=script&lang=js&"
export * from "./testTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports